import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NavbarComponent} from '../core/components/navbar/navbar.component';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputNumberModule} from 'primeng/inputnumber';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TooltipModule} from 'primeng/tooltip';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {TimelineModule} from 'primeng/timeline';
import {ToastModule} from 'primeng/toast';
import {AvatarModule} from "primeng/avatar";
import {ConfirmationService} from "primeng/api";
import { DialogModule } from "primeng/dialog";
import { MenuModule } from 'primeng/menu';
import { InrPatientAttachmentsComponent } from './components/inr-patient-attachments/inr-patient-attachments.component';
import { CalendarModule } from 'primeng/calendar';
import { SidebarComponent } from '../core/components/sidebar/sidebar.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableHeaderComponent } from './components/table-header/table-header.component';

@NgModule({
  declarations: [NavbarComponent, SidebarComponent, InrPatientAttachmentsComponent, TableHeaderComponent],
  imports: [MaterialModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ButtonModule,
    TableModule,
    DropdownModule,
    InputTextModule,
    InputSwitchModule,
    InputTextareaModule,
    InputNumberModule,
    ConfirmDialogModule,
    DialogModule,
    MenuModule,
    CalendarModule,
    TooltipModule,
    BreadcrumbModule,
    TimelineModule,
    ToastModule,
    AvatarModule,
    ProgressBarModule

  ],
  exports: [
    NavbarComponent,
    SidebarComponent,
    InrPatientAttachmentsComponent,
    TableHeaderComponent,
    FormsModule,
    RouterModule,
    ButtonModule,
    TableModule,
    AvatarModule,
    DropdownModule,
    InputTextModule,
    InputSwitchModule,
    InputTextareaModule,
    InputNumberModule,
    ConfirmDialogModule,
    TooltipModule,
    BreadcrumbModule,
    TimelineModule,
    ToastModule,
    DialogModule,
    MenuModule,
    CalendarModule,
    ProgressBarModule

  ],
  providers: [ConfirmationService]
})
export class SharedModule {
}
